import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface errorStepData {
  nsoError: null | {
    color: string;
    displayName: string;
    displayStep: number;
    error: string;
    errorLambda: string | null;
    errorMsg: string;
    id: number;
    name: string;
    step: number;
  };
  simError: null | {
    color: string;
    displayName: string;
    displayStep: number;
    error: string;
    errorLambda: string | null;
    errorMsg: string;
    id: number;
    name: string;
    step: number;
  };
}
const errorStepInitialState: errorStepData = {
  nsoError: null,
  simError: null,
};

const storedState: any = localStorage.getItem("nsoFlowState");
const initialState: errorStepData =
  storedState && JSON.parse(storedState).length > 0
    ? JSON.parse(storedState)
    : {
        errorStep: errorStepInitialState,
      };

export const erroStepSlice = createSlice({
  name: "errors",
  initialState: initialState,
  reducers: {
    setNsoError: (state, action: PayloadAction<errorStepData["nsoError"]>) => {
      state.nsoError = action.payload;
    },
    clearNsoError: (state) => {
      state.nsoError = null;
    },
    setSimError: (state, action: PayloadAction<errorStepData["simError"]>) => {
      state.simError = action.payload;
    },
    clearSimError: (state) => {
      state.simError = null;
    },
  },
});

export const { setNsoError, clearNsoError, setSimError, clearSimError } = erroStepSlice.actions;

export const errorStepReducer = erroStepSlice.reducer;
erroStepSlice.reducer = (state: any, action: any) => {
  const newState = errorStepReducer(state, action);
  localStorage.setItem("errorStep", JSON.stringify(newState));
  return newState;
};

export default erroStepSlice.reducer;
